import { Component, AfterViewInit, OnInit, Input } from '@angular/core';
import { SharedService } from '../service/shared.service';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { FormControl,FormGroup, Validators, FormsModule, ReactiveFormsModule} from '@angular/forms';
import { configuration } from 'src/configuration';
import { ApiServiceService } from '../service/api-service.service';

@Component({
  selector: 'app-contact-us-model',
  templateUrl: './contact-us-model.component.html',
  styleUrls: ['./contact-us-model.component.css']
})
export class ContactUsModelComponent {

  submit = false;
  isSubmitted = false;
  myFormSubmit = false;
  @Input() showContactInfo = true;
  @Input() contact_type:any;
  contactForm: any = new FormGroup({
    name: new FormControl('', [Validators.required]),
    email: new FormControl('', [Validators.required]),
    // subject: new FormControl('', [Validators.required]),
    message: new FormControl('', [Validators.required]),
  });
  constructor(private fb: FormBuilder, public shared: SharedService, private apiService: ApiServiceService) {
  }
  

  ngOnInit(): void {
    if (this.showContactInfo) {
      this.contactForm.addControl('subject', new FormControl('', [Validators.required]));
    }else{
      this.contactForm.addControl('mobile', new FormControl('', [Validators.required]));
    }
  }
  
  ngAfterViewInit(): void {
      this.shared.includeMainScript();
  }
  
  async submitForm() {
    this.myFormSubmit = true;
    console.log(this.contactForm.value);

    let json: any = this.contactForm.value
    if (this.contact_type) {
      json.contact_type = this.contact_type
    } else {
      json.contact_type = 3
    }
    console.log("json",json)
    let res = await this.apiService.POST_apiRequest(configuration.ENDPOINT.CONTACT_US, this.contactForm.value);

    if (res && !res.error) {
      this.isSubmitted = true;
      this.contactForm.reset()
    } else {
      console.error("Error submitting the form:", res);
    }
  }
  
  onSubmit() {
    this.submitForm();
  }
  
}


